import { SET_INVOICES_DATA, SET_PAYMENT_METHOD_DATA } from './subscriptionTypes';

const initialState = {
  paymentMethods: undefined,
  invoices: undefined,
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INVOICES_DATA:
      return { ...state, invoices: action.payload };
    case SET_PAYMENT_METHOD_DATA:
      return { ...state, paymentMethods: action.payload };
    default:
      return { ...state };
  }
};

export default subscriptionReducer;
